export interface Keybinds {
  onSpace: () => void;
  onPrevSentence: () => void;
  onNextSentence: () => void;
  onPrevCourse: () => void;
  onNextCourse: () => void;
  onSeekBack: () => void;
  onSeekFwd: () => void;
  onBackspace: () => void;
}

function isTypingContext(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  if (!el) return false;
  const tag = el.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  return el.isContentEditable === true;
}

export function bindKeys(binds: Keybinds): () => void {
  const handler = (e: KeyboardEvent) => {
    if (e.metaKey || e.altKey || e.ctrlKey) return;
    if (isTypingContext(e.target)) return;
    if (e.repeat && (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
      return;
    }
    switch (e.key) {
      case ' ':
      case 'Spacebar':
        e.preventDefault();
        binds.onSpace();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        if (e.shiftKey) binds.onSeekBack();
        else binds.onPrevSentence();
        break;
      case 'ArrowRight':
        e.preventDefault();
        if (e.shiftKey) binds.onSeekFwd();
        else binds.onNextSentence();
        break;
      case 'ArrowUp':
        e.preventDefault();
        binds.onPrevCourse();
        break;
      case 'ArrowDown':
        e.preventDefault();
        binds.onNextCourse();
        break;
      case 'Backspace':
        binds.onBackspace();
        break;
    }
  };
  window.addEventListener('keydown', handler);
  return () => window.removeEventListener('keydown', handler);
}
